/** DRW-LOAD-C §1 — the read retry policy, in one place so it can be reasoned about and tested.
 *
 *  Object storage answers a small object in ~0.2s and then, about once in fifty, stalls: a 0.6MB
 *  sheet measured 28.17s. The old client had either no timeout at all or a 30s one, so a single
 *  stall reached the user as a dead request and reached the link detector as "no connectivity".
 *  Now a read gets a few seconds, two retries with growing gaps, and only then the cache.
 *
 *  A WRITE is never retried here: one that got no answer may already have landed, so it belongs in
 *  the outbox, which de-duplicates by client write id.
 */
export const RETRY_ATTEMPTS = 3;
const DELAYS_MS = [400, 1200];

export const retryDelayMs = (attempt) => DELAYS_MS[attempt - 1] ?? 0;

/** `verdict` is `classify()`'s answer. `blocked` says the app has already given up on the network
 *  (detector offline or the manual switch), in which case the cache answers at once instead. */
export function shouldRetry(cfg = {}, verdict = "", attempt = 1, blocked = false) {
  if ((cfg.method || "get").toLowerCase() !== "get") return false;
  if (cfg._replay || cfg._noRetry || blocked) return false;
  if (attempt >= RETRY_ATTEMPTS) return false;
  return verdict === "inconclusive" || verdict === "netfail";
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
